/* Local dependencies */
import { animation } from './theme/animation';
import { colors } from './theme/colors';
import { layout } from './theme/layout';
import { semantic } from './theme/semantic';
import { shadows } from './theme/shadows';
import { typography } from './theme/typography';

export const theme = {
  colors,
  layout,
  typography,
  shadows,
  animation,
  semantic,
};
